import Vue from 'vue';
export const activeMenuMixin = Vue.extend({
    computed: {
        scrollHash: {
            get() {
                return this.$store.state.scrollHash;
            },
            set(val) {
                this.$store.commit('setScrollHash', val);
            },
        },
        activeMenu: {
            get() {
                return this.$store.state.activeMenu;
            },
            set(val) {
                this.$store.commit('setActiveMenu', val);
            },
        },
    },
});
